import { createContext } from "react";

// create a context with default values
const controlContext = createContext({
  currMode: "rect",
  changeCurrMode: () => {},
  currBorderColor: "",
  changeCurrBorderColor: () => {},
  currBorderWidth: 1,
  changeCurrBorderWidth: () => {},
  currFillColor: "",
  changeCurrFillColor: () => {},
  currFontFamily: "Arial",
  changeCurrFontFamily: () => {},
  currFontSize: 12,
  changeCurrFontSize: () => {},

  shapes: [],
  shapesMap: {},
  addShape: () => {},
  updateShape: () => {},
  selectedShapeId: "", // a string or undefined
  selectShape: () => {},
  deleteSelectedShape: () => {},

  framesMap: {},
  selectedFrameId: "",

  undo: () => {},
  redo: () => {},
  undoable: () => {},
  redoable: () => {},
});

export default controlContext;
